export const userAgreementColumn = [
  {
    headerName: "번호",
    field: "num",
    width: 122,
  },
  {
    headerName: "등록일시",
    field: "createdAt",
    width: 244,
  },
  {
    headerName: "은행",
    field: "accountBank",
    width: 204,
  },
  {
    headerName: "계좌번호",
    field: "accountNumber",
    width: 219,
  },
  {
    headerName: "예금주",
    field: "accountName",
    width: 200,
  },
];
